import addHours from 'date-fns/addHours';
import addMonths from 'date-fns/addMonths';
import format from 'date-fns/format';
import startOfHour from 'date-fns/startOfHour';

const FORMAT_STR = 'yyyy-MM-dd HH:mm:ss';

const getFutureFormattedDate = (hours = 0) =>
    format(startOfHour(addHours(addMonths(new Date(), 2), hours)), FORMAT_STR);

export const mockSessions = [
    {
        id: 1,
        tags: ['Example Tag 1', 'Example Tag 2', 'Example Tag 3', 'Example Tag 4'],
        speakers: [
            {
                id: 1,
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
            },
            {
                id: 2,
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
            },
        ],
        name: 'Session example',
        description:
            'This is where the description for the current session will appear. Visit any session in the Session Manager to edit the content. ',
        registration_required: true,
        status: 'open',
        waitlist: false,
        start: getFutureFormattedDate(),
        end: getFutureFormattedDate(1),
    },
    {
        id: 2,
        tags: ['Example Tag 1', 'Example Tag 2'],
        speakers: [
            {
                id: 1,
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
            },
        ],
        name: 'Waitlisted session example',
        description:
            'This is where the description for the current session will appear. Visit any session in the Session Manager to edit the content.',
        registration_required: true,
        attendee_count: 0,
        capacity: 0,
        status: 'closed',
        waitlist: true,
        start: getFutureFormattedDate(0),
        end: getFutureFormattedDate(2),
    },
];
